export default [
  {
    path: '/activity-20251215-main',
    component: () => import('./Page.vue'),
    meta: { title: '荣耀殿堂', id: 12 },
  },
  {
    path: '/activity-20251215-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '荣耀殿堂-规则', id: 12 },
  },
]
